const EnvVars = {
  GRAPHQL_URI: import.meta.env.VITE_GRAPHQL_URI ?? "https://www.optimus-steelusa.app/pascal",
  AZURE_AUTH_CLIENT_ID: "93fe6266-202a-4e1d-a7eb-5e7dd646db0c",
  AZURE_AUTH_AUTHORITY: "https://login.microsoftonline.com/0bd5d348-70a7-4e01-92d1-818e0e836823",
  AZURE_AUTH_REDIRECT_URI: "/",
  AZURE_AUTH_POST_LOGOUT_REDIRECT_URI: "/",
  AZURE_AUTH_API_SCOPE: "api://93fe6266-202a-4e1d-a7eb-5e7dd646db0c/access_as_user",
  ACQUISITION_WS: import.meta.env.VITE_ACQUISITION_WS ?? "wss://www.optimus-steelusa.app/realtime",
  ACQUISITION_API: import.meta.env.VITE_ACQUISITION_API ?? "https://www.optimus-steelusa.app/realtime",
  LOCAL_MODE: "0"
};

export default EnvVars;